<template>
    <v-navigation-drawer
      v-model="Menus"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
        <v-list dense>
        <template  v-for="item in items">
          <v-layout
            v-if="item.heading"
            :key="item.heading"
            row
            align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex
              xs6
              class="text-xs-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-flex>
          </v-layout>
          
          
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.type == user.type || typeof item.type === 'undefined'?item.model ? item.icon : item['icon-alt']:null"
            append-icon=""
          >
            <template v-slot:activator v-if="item.type == user.type || typeof item.type === 'undefined'">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-if="item.type == user.type || typeof item.type === 'undefined'">
            
              <v-list-item
              class="ml-5"
              v-for="(child, i) in item.children"
              :key="i"
              @click="clickss(child.route)"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>    
              
            </template>    
            
        
          </v-list-group>
         
         
         
          <v-list-item
            v-else
            :key="item.text"
            @click="clickss(item.route)"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

    </v-navigation-drawer>
</template>
<script>
export default {
    data(){

        return {
            dialog: false,
            drawer: true,
            items: [
                
              {
                    //type:'administrador',
                    icon: 'mdi-chevron-up',
                    'icon-alt': 'mdi-chevron-down',
                    text: 'Usuarios',
                    model: false,
                        children: [
                              { icon: 'mdi-account-multiple', text: 'Usuarios', route:'/usuarios'},
                              
                        ],
                },



                {
                    icon: 'mdi-chevron-up',
                    'icon-alt': 'mdi-chevron-down',
                    text: 'Equipo',
                    model: true,
                        children: [
                            { icon: 'mdi-car', text: 'Vehículos', route:'/vehiculo'},
                            { icon: 'mdi-account-box', text: 'Conductores', route:'/conductor'},
                            { icon: 'mdi-clipboard-check', text: 'Asignación', route:'/asignacion'},
                            { icon: 'mdi-map-marker-multiple', text: 'Sucursales', route:'/config/sucursales'},
                            { icon: 'mdi-factory', text: 'Empresas', route:'/config/empresas'},

                        ],
                },

             //   {
             //       icon: 'mdi-chevron-up',
             //       'icon-alt': 'mdi-chevron-down',
             //       text: 'Reporte',
             //       model: false,
             //           children: [
             //               { icon: 'mdi-paperclip', text: 'Lista de reporte', route:'/reporte'},
             //               { icon: 'mdi-clipboard-text', text: 'Crear nuevo reporte', route:'/reporte'},
              //          ],
              //  },


                {
                    icon: 'mdi-chevron-up',
                    'icon-alt': 'mdi-chevron-down',
                    text: 'Registro',
                    model: false,
                        children: [
                            { icon: 'mdi-calendar-check', text: 'Lista de registro', route:'/registro'},
                            { icon: 'mdi-plus', text: 'Crear registro nuevo', route:'/registro/crear'},
                        ],
                },


              //  {
              //      icon: 'mdi-chevron-up',
              //      'icon-alt': 'mdi-chevron-down',
               //     text: 'Sincronizacion',
               //     model: false,
               //         children: [
               //             { icon: 'mdi-wifi', text: 'Lista de sincronizacion', route:'/'},
               //             { icon: 'mdi-calendar-clock', text: 'Actualizaciones pendientes', route:'/'},
                //        ],
               // },


                {
                    type:'administrador',
                    icon: 'mdi-chevron-up',
                    'icon-alt': 'mdi-chevron-down',
                    text: 'Excepciones',
                    model: false,
                        children: [
                            { icon: 'mdi-view-list', text: 'Excepción activa', route:'/exepciones'},
                            { icon: 'mdi-qrcode', text: 'Generar codigo de excepcion', route:'/exepciones/crear'},
                            
                        ],
                },


              //  {
              //      icon: 'mdi-chevron-up',
               //     'icon-alt': 'mdi-chevron-down',
                //    text: 'Configuracion',
                //    model: false,
                //        children: [
                          //  { icon: 'mdi-settings-box', text: 'configuracion', route:'/config'},
                //        ],
                //},
                
                

                
                

                
             ],


        }

    },

    computed: {


        user(){
          return this.$store.state.currentUser.user;
        },

        Menus:
            {
                get()
                {
                    return this.$store.state.drawer
                },
                set(value)
                {
                    this.value = value
                }
            }

        
    },

    methods: {
      clickss:function(path){

        this.$router.push({path: path}, ()=>{});
        this.$store.dispatch('MenuEquipo', false);

      }

    },

}

//{ icon: 'mdi-contacts', text: 'Contacts' },
//{ icon: 'mdi-history', text: 'Frequently contacted' },
//{ icon: 'mdi-content-copy', text: 'Duplicates' },
//{
//    icon: 'mdi-chevron-up',
//   'icon-alt': 'mdi-chevron-down',
//   text: 'More',
//   model: false,
//   children: [
//   { text: 'Import' },
//   { text: 'Export' },
//   { text: 'Print' },
//   { text: 'Undo changes' },
//   { text: 'Other contacts' },
//   ],
//},
// { icon: 'mdi-settings', text: 'Settings' },
// { icon: 'mdi-message', text: 'Send feedback' },
// { icon: 'mdi-help-circle', text: 'Help' },
// { icon: 'mdi-cellphone-link', text: 'App downloads' },
// { icon: 'mdi-keyboard', text: 'Go to the old version' },
</script>

